import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  continue: {
    id: 'QJr9Wm',
    defaultMessage: 'Next',
    description: 'Button text to continue',
  },
  shipFrom: {
    id: 'HUlkWg',
    defaultMessage: 'Ship From: {shipFromName}',
    description: 'title that describes the ship from dropdown',
  },
  batchName: {
    id: 'hrZbJ/',
    defaultMessage: 'Batch Name: {batchName}',
    description: 'title that describes the batch name',
  },
  autogeneratedBatchName: {
    id: 'x62tVT',
    defaultMessage: '--auto generated--',
    description: 'Placeholder for autogenerated batch name',
  },
  batchNameLabel: {
    id: 'EluZnz',
    defaultMessage: 'Batch Name',
    description: 'label that describes the batch name',
  },
  batchNameSubLabel: {
    id: 'sV8dIg',
    defaultMessage: 'A name will be auto generated if left blank',
    description: 'sub-label that describes the batch name',
  },
  modalActionMessage: {
    id: 'sv3H8R',
    defaultMessage: 'Confirm',
    description: 'Label for a button to confirm items are ready to be picked',
  },
  modalCancelMessage: {
    id: 'aD7ZQk',
    defaultMessage: 'Cancel',
    description: 'Label for a button to cancel ready to be picked modal',
  },
  modalHeaderMessageOrder: {
    id: 'dbQZ4O',
    defaultMessage: 'Ready to Pick',
    description: 'Header text for ready to be picked modal for orders',
  },
  modalHeaderMessageBatch: {
    id: '9/ov1N',
    defaultMessage: 'Ready to Pick: Verify Batch',
    description: 'Header text for ready to be picked modal for batches',
  },
  readyToPickButton: {
    id: 'EjNcqr',
    defaultMessage: 'Ready To Pick',
    description: 'button in the header of the grid that allows user to move a batch to ready to pick',
  },
  verifyCardDescription: {
    id: 'pVdJxc',
    defaultMessage: 'To mark these orders as Ready to Pick, please confirm the Ship From location and, optionally, rename this batch.',
    description: 'Ready to Pick Modal Verify Information Card Description',
  },
  step1TitleOrders: {
    id: 'Ly9znU',
    defaultMessage: 'Select location and method',
    description: 'Ready to Pick Modal step 1 Card Title for orders',
  },
  step1TitleBatches: {
    id: 'y/wyrg',
    defaultMessage: 'Verify batch details',
    description: 'Ready to Pick Modal step 1 Card Title for batches',
  },
  step1BodyOrders: {
    id: '0miYJf',
    defaultMessage:
      'Ready to pick orders can either be added to a new batch or a queue of orders to pick. Be sure to confirm the ship from location and choose the picking method.',
    description: 'Ready to Pick Modal step 1 Card body for orders',
  },
  step1BodyBatches: {
    id: 'DUEWfm',
    defaultMessage: 'Confirm the ship from location for these ready to pick orders. You can also rename the batch if desired.',
    description: 'Ready to Pick Modal step 1 Card body for batches',
  },
  verifyShipFromTitle: {
    id: 'vtMvvY',
    defaultMessage: 'Ship From Location',
    description: 'Ready to Pick Modal Verify Information Card Ship From Title',
  },
  checkForOrderErrors: {
    id: '0zHbc8',
    defaultMessage: 'Check for order errors',
    description: 'Ready to Pick Modal Verify Information Card Check for Order Errors',
  },
  checkForInventoryErrors: {
    id: 'AMhgF3',
    defaultMessage: 'Check for inventory errors',
    description: 'Ready to Pick Modal Verify Information Card Check for Inventory Errors',
  },
  checkForInventoryErrorsBody: {
    id: '38n/1w',
    defaultMessage:
      'Orders with inventory errors cannot be picked. Inventory errors must be resolved or the orders removed from the batch to continue.',
    description: 'Ready to Pick Modal Verify Information Card body Check for Inventory Errors',
  },
  step2BodyOrders: {
    id: '10WSgr',
    defaultMessage:
      'Orders that have already begun picking cannot be picked. Additionally, this action will move orders that are already in a batch into a new batch.',
    description:
      'Ready to Pick Modal Verify Information Card - Has order errors and will need to removed from batch or resolved - for orders',
  },
  step2BodyBatches: {
    id: '3FCOOJ',
    defaultMessage:
      'Orders that are in an incompatible status or have already begun picking cannot be picked. Additionally, please ensure the On Hold and Awaiting Payment orders are ready to be picked..',
    description:
      'Ready to Pick Modal Verify Information Card - Has order errors and will need to removed from batch or resolved - for batches',
  },
  createPickBatchFromLabelBatchSuccessTitle: {
    id: 'mQlCSw',
    defaultMessage: 'Success',
    description: 'Ready to Pick Modal Success notification Title',
  },
  createPickBatchFromLabelBatchSuccessMessage: {
    d: 'sTbo8K',
    defaultMessage:
      '{count, plural, one {The order has} other {# orders have}} been added to the batch "{batchName}" and {count, plural, one {is} other {are}} ready to pick',
    id: 'nPOmk8',
    description: 'Ready to Pick Modal Success Message',
  },
  addOrdersToPickingQueueSuccessMessage: {
    id: 'nj8k79',
    defaultMessage:
      '{count, plural, one {The order has} other {# orders have}} been added to the picking queue and {count, plural, one {is} other {are}} ready to pick',
    description: 'Ready to Pick Modal Success Message',
  },
  createPickBatchFromLabelBatchError: {
    id: 'pV4dU0',
    defaultMessage: 'There was an error marking your orders as ready to pick: {error}.',
    description: 'Ready to Pick Modal Success Message',
  },
  createPickBatchFromLabelBatchFailureTitle: {
    id: 'x59y7t',
    defaultMessage: 'Error',
    description: 'Ready to Pick Modal Error Title',
  },
  createPickBatchFromLabelBatchFailureMessage: {
    id: 'H8U8XE',
    defaultMessage: 'There was an issue marking your orders as Ready to Pick. Please try again.',
    description: 'Ready to Pick Modal Error Message',
  },
  handleBulkUpdateSaveValidateFailureTitle: {
    id: 'Ay+l/V',
    defaultMessage: 'Error',
    description: 'Ready to Pick Modal Bulk Update or Save & Validate Failure Error Title',
  },
  handleBulkUpdateSaveValidateFailureMessage: {
    id: 'VgSU3d',
    defaultMessage: 'There was an issue saving or validating your orders as Ready to Pick. Please try again.',
    description: 'Ready to Pick Modal Bulk Update or Save & Validate Failure Error Message',
  },
  handleCreateNewBatchFailureTitle: {
    id: 'ygQb1D',
    defaultMessage: 'Error',
    description: 'Ready to Pick Modal Create New Batch Failure Error Title',
  },
  handleCreateNewBatchFailureMessage: {
    id: 'kYNM2Q',
    defaultMessage: 'There was an issue creating a new batch. Please try again.',
    description: 'Ready to Pick Modal Create New Batch Failure Error Message',
  },
  handleAllocationErrorTitle: {
    id: '8iwmzP',
    defaultMessage: 'Allocation Error',
    description: 'Ready to Pick Modal Create New Batch Failure Error Title',
  },
  handleAllocationErrorMessage: {
    id: 'vCpBPj',
    defaultMessage: 'There was an issue allocating the orders in your batch. Please try again.',
    description: 'Ready to Pick Modal Create New Batch Failure Error Message',
  },
  orderErrorsRemoveButton: {
    id: 'xLY/4u',
    defaultMessage: 'Remove Orders',
    description: 'Ready to Pick Modal Order Errors Remove Button',
  },
  buttonDisabledTooManyOrders: {
    id: 'kzT0gU',
    defaultMessage: 'This action is unavailable for more than {max} orders',
    description: 'Ready to Pick Modal Button Disabled Already Processed for orders',
  },
  buttonDisabledIsDemoOrder: {
    description: 'Disabled message for Hold button when demo orders are selected',
    defaultMessage: 'This action is disabled for Demo Orders',
    id: 'L11ehM',
  },
  retryAllocation: {
    id: 'K4Sjl2',
    defaultMessage: 'Retry',
    description: 'Ready to Pick Modal Retry Allocation Button',
  },
  editBatchInfo: {
    id: 'XtWTJH',
    defaultMessage: 'Edit',
    description: 'Ready to Pick Modal Edit Batch Information Button',
  },
  orderStatusError: {
    id: 'ii7ChG',
    defaultMessage: 'Order is {orderStatus}',
    description: 'order validation error message for order status',
  },
  orderPickingError: {
    id: 'osuBpD',
    defaultMessage: 'Order is already {pickingStatusName}',
    description: 'order validation error message for order already being picked',
  },
  orderBatchError: {
    id: 'hJu8r4',
    defaultMessage: 'Order is in existing batch',
    description: 'order validation error message for order already another batch',
  },
  noInventoryError: {
    id: 'FTgNiU',
    defaultMessage: 'This Ship From location is not configured to use inventory',
    description: 'ShipFrom validation error message not having an inventory warehouse configured',
  },
  noNativeInventoryError: {
    id: 'MTmeoX',
    defaultMessage: 'Mobile picking does not support the external inventory warehouse linked to this Ship From',
    description: 'ShipFrom validation error message not having a native inventory warehouse configured',
  },
  pickingMethodTitle: {
    id: 'b0MLb9',
    defaultMessage: 'Picking Method',
    description: 'Title for the picking method section',
  },
  addToPickingQueue: {
    id: 'tV6ffJ',
    defaultMessage: 'Add to picking queue',
    description: 'Radio button option to add orders to picking queue',
  },
  addToPickingQueueDescription: {
    id: 'tkwwSr',
    defaultMessage: 'Orders will be picked in first-in, first-out order by the next available picker',
    description: 'Description for add to picking queue option',
  },
  addToNewBatch: {
    id: 'M8e9iN',
    defaultMessage: 'Add to new batch',
    description: 'Radio button option to add orders to new batch',
  },
  addToNewBatchDescription: {
    id: '/UKfaU',
    defaultMessage: 'Group specific orders to be picked',
    description: 'Description for add to new batch option',
  },
  pickingMethodSummary: {
    id: 'P5nwRl',
    defaultMessage: 'Picking Method: {pickingMethod}',
    description: 'Summary of selected picking method',
  },
});
